import { Button, Card, Form, Input, Typography, Layout, message } from "antd";
import { UserOutlined, LockOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useState } from "react";
import { MEMBER_LOGIN } from "../../services/apiEndPoints";
import axios from "../../services/axiosInstance";
import { useAuth } from "../../context/AuthContext";
import { Link, Navigate, useNavigate } from "react-router-dom";

const { Title, Text } = Typography;
const { Content } = Layout;

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        // Basic validation
        if (!email) {
            message.error("Email is required");
            return;
        }

        if (!password) {
            message.error("Password is required");
            return;
        }

        try {
            setLoading(true);
            const response = await axios.post(MEMBER_LOGIN, {
                memberEmail: email,
                password,
            });

            if (response && response.data && response.data.token) {
                localStorage.setItem("token", response.data.token);
                login(response.data.token);
                message.success("Logged in successfully");
                setTimeout(() => {
                    navigate("/");
                }, 1000);
            } else {
                message.error("Invalid login response");
            }

        } catch (error: any) {
            console.error("Login error:", error);

            message.error(
                error?.response?.data?.message || "Login failed. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout className="login-layout">
            {/* Decorative Side */}
            <div className="login-decor">
                <div className="decor-circle decor-1" />
                <div className="decor-circle decor-2" />

                <div className="decor-content">
                    <Title level={2} style={{ color: "#fff" }}>
                        Welcome Back 👋
                    </Title>
                    <Text style={{ color: "#e5e7eb" }}>
                        Sign in to access your dashboard
                    </Text>
                </div>
            </div>

            {/* Login Form */}
            <Content className="login-content">
                <Card className="login-card">
                    <Title level={3}>Sign In</Title>

                    <Form layout="vertical" onFinish={handleSubmit}>
                        <Form.Item
                            label="Email"
                            name="memberEmail"
                            rules={[
                                { required: true, message: "Enter your email" },
                                { type: "email", message: "Enter a valid email" },
                            ]}
                        >
                            <Input
                                prefix={<UserOutlined />}
                                placeholder="you@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Enter your password" }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            size="large"
                            loading={loading}
                        >
                            Login
                        </Button>

                        <Link to="/forget-password" >
                            <Button
                                type="link"
                                block
                                icon={<ArrowLeftOutlined />}
                                style={{ marginTop: 12 }}
                            >
                                Forget Password?
                            </Button>
                        </Link>

                        <Text type="secondary" style={{ display: "block", marginTop: 16 }}>
                            © 2025 Access Warehousing
                        </Text>
                    </Form>
                </Card>
            </Content>
        </Layout>
    );
}
